// extracted by mini-css-extract-plugin
module.exports = {"back":"BackButton_back__2hT-x","back-icon":"BackButton_back-icon__2DC1J","back-text":"BackButton_back-text__3CWWg"};